import React from "react";
import { Button } from "@mui/material";

type NextButtonProps = {
  onNext: () => void;
  isValid: boolean;
  label?: string;
}

const NextButton: React.FC<NextButtonProps> = ({
  onNext,
  isValid,
  label = "Next",
}) => {
  const handleClick = (): void => {
    onNext();
  };

  return (
    <Button
      size="large"
      color="primary"
      variant="contained"
      onClick={handleClick}
      aria-disabled={!isValid}
      sx={isValid ? null : (theme) => ({
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.action.disabled,
      })}
    >
      {label}
    </Button>
  );
};

export default NextButton;


